
import WebService from "../../WebService"

const LiveProduct = {
    gets(params) {
        
        return WebService.get("/console/contest/products?" + params)
    },
    get(id, e = null) {
        return WebService.get("/console/contest/products/" + id + '?e=' + e)
    },
    create(data) {
        return WebService.post("/console/contest/products", data)
    },
    update(data) {
        return WebService.post("/console/contest/products/" + data.product_id, data)
    },
    upload(speaker_id, data) {
        return WebService.post("/console/contest/products/" + speaker_id, data)
    }
}
export default LiveProduct